module.exports = __webpack_public_path__ + "img/portraits_21_V.63820a6b.webp";